/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

// ACTIVITIES

export const GET_ACTIVITIES = 'GET_ACTIVITIES';
export const GET_ACTIVITIES_SUCCESS = 'GET_ACTIVITIES_SUCCESS';

export const GET_ACTIVITY_SINGLE = 'GET_ACTIVITY_SINGLE';
export const GET_ACTIVITY_SINGLE_SUCCESS = 'GET_ACTIVITY_SINGLE_SUCCESS';

export const CREATE_ACTIVITY = 'CREATE_ACTIVITY';
export const CREATE_ACTIVITY_SUCCESS = 'CREATE_ACTIVITY_SUCCESS';

export const EDIT_ACTIVITY = 'EDIT_ACTIVITY';
export const EDIT_ACTIVITY_SUCCESS = 'EDIT_ACTIVITY_SUCCESS';

export const DELETE_ACTIVITY = 'DELETE_ACTIVITY';
export const DELETE_ACTIVITY_SUCCESS = 'DELETE_ACTIVITY_SUCCESS';

// VIX WAX

export const VIS_WAX = 'VIS_WAX';
export const VIS_WAX_SUCCESS = 'VIS_WAX_SUCCESS';

// NEMI FOREST

export const NEMI_FOREST = 'NEMI_FOREST';
export const NEMI_FOREST_SUCCESS = 'NEMI_FOREST_SUCCESS';

// ERROR

export const ERROR = 'ACTIVITY_ERROR';